const VocabularyQ = {
    topic: 'Vocabulary',
    level: 'Beginner',
    totalQuestions: 10,
    perQuestionScore: 1,
    questions: [
       {
         question:
           'By this time of next month, I----------all my exams',
         choices: ['will have taken', 'will take', 'take','have taken' , 'taken'],
         type: 'MCQs',
         correctAnswer: 'will have taken',
       },
       {
         question:
           'How long he --------------there?',
         choices: ['been waited','been waiting', 'waiting','had been waiting','waits so'],
         type: 'MCQs',
         correctAnswer: 'had been waiting',
       },
       {
         question:
           'That wasn’t a good idea – he----------------thought about it more carefully.',
         choices: [ 'have to','ought have','should have','must have','had' ],
         type: 'MCQs',
         correctAnswer: 'should have',
       },
       {
         question: ' I have often attempted to discuss a solution to his problem with him yet-------------------excuses and evasion.',
         choices: ['encounters','have encountered','have been encountered','encountering', 'encounter'],
         type: 'MCQs',
         correctAnswer: 'encounter',
       },
       {
         question: 'Somebody left a cell phone in the conference room. Does anybody here know------------?',
         choices: ['who it belongs' , 'whose its' , 'who is it belonging to' , 'whose it is', 'whom it belongs'],
         type: 'MCQs',
         correctAnswer: 'who is it belonging to',
       },
       {
         question: '"I dont like black tea." "--------------do I.',
         choices: [' So' , 'Neither', 'Either' , 'Rather', 'No'],
         type: 'MCQs',
         correctAnswer: 'Neither',
       },
       {
         question: 'She told me that she------------------in London the previous year.',
         choices: ['has been working','had been working','has worked','had been worked','had working'],
         type: 'MCQs',
         correctAnswer: 'had been working',
       },
       {
         question: '--------------- around, he ensured thorough co-ordination.',
         choices: ['Despite of not being','Not there','Despite not being','Though he not','He was not'],
         type: 'MCQs',
         correctAnswer: 'Despite of not being',
       },
      {
        question: 'I------------a reply to my application in the next few days.',
        choices: ['hope' , 'expect', 'wait for' , 'get' , 'ask'],
        type: 'MCQs',
        correctAnswer: 'expect',
      },
      {
        question: 'It---------------my aunt.',
        choices: ['is ages that I didnt see','has been ages since I saw','was ages that I havent seen','was ages since I saw','been ages'],
        type: 'MCQs',
        correctAnswer: 'has been ages since I saw',
      },
     
    ],
  }
export default VocabularyQ